import React, { Component } from 'react'
import DataTableWithOutSearch from '../datatables/DataTableWithOutSearch';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import moment from 'moment';
import PageCardShimmer from '../preloader/PageCardShimmer';

import { withRouter } from "react-router-dom";

const FETCH_PROCTORING_EXAMS = gql`
query($institution_id: Int!, $exam_id: Int) {
  getProctoringExams(institution_id: $institution_id, exam_id: $exam_id){
    mobile
    exam_name
    proctoring_type_id
    exam_paper_id
    inserted_at
    estatus
  }
}
`;

class ProctoringStudentDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tableHeaderData: {
                Title: 'Proctoring Student Details'
            }
        }
    }

    articlecolumns = [
        {
            dataField: "examName",
            text: "Exam Name",
            sort: true
        },
        {
            dataField: "dateTime",
            text: "Time & Date",
            sort: true
        },
        {
            dataField: "mobile",
            text: "Mobile",
            sort: true
        },
        {
            dataField: "proctoringType",
            text: "Proctoring Type",
            sort: true
        },
        {
            dataField: "status",
            text: "Status",
            sort: true
        }
    ];

    defaultSorted = [
        {
            dataField: "dateTime",
            order: "desc"
        }
    ];

    tableUserData(proctoringExams) {
        if (!proctoringExams) return [];

        return proctoringExams.map((exam, index) => ({
            id: index + 1,
            examName: exam.exam_name,
            dateTime: exam.inserted_at ? moment(exam.inserted_at).format("YYYY-MM-DD | hh:mm A") : "N/A",
            mobile: exam.mobile,
            proctoringType: exam.proctoring_type_id,
            status: exam.estatus
        }));
    }

    render() {
        const { getProctoringExams } = this.props;

        if (getProctoringExams && getProctoringExams.loading) {
            return <PageCardShimmer filters={0} cols={5} />;
        }

        if (getProctoringExams && getProctoringExams.error) {
            return (
                <div className="alert alert-danger">
                    Error loading proctoring exams: {getProctoringExams.error.message}
                </div>
            );
        }

        const examsData = getProctoringExams ? getProctoringExams.getProctoringExams : [];

        const rows = this.tableUserData(examsData);

        return (
            <div className="user-creation py-4">
                <div style={{ width: "100%", background: "#fff", borderRadius: 16, border: "1px solid #e2e8f0", boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden" }}>
                    {/* ── Header ── */}
                    <div style={{ background: "linear-gradient(135deg,#6366f1,#8b5cf6)", padding: "18px 24px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
                        <div className="d-flex align-items-center" style={{ gap: 12 }}>
                            <div style={{ width: 42, height: 42, borderRadius: 10, background: "rgba(255,255,255,0.18)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <i className="fal fa-video" style={{ color: "#fff", fontSize: 20 }} />
                            </div>
                            <div>
                                <div style={{ color: "#fff", fontWeight: 700, fontSize: 17 }}>Proctoring Students</div>
                                <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 12 }}>Proctoring activity for the exam</div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center" style={{ gap: 10 }}>
                            <span style={{ background: "rgba(255,255,255,0.2)", color: "#fff", borderRadius: 20, padding: "4px 14px", fontSize: 13, fontWeight: 700 }}>
                                {rows.length} Records
                            </span>
                            <button
                                type="button"
                                onClick={() => this.props.history.goBack()}
                                className="d-flex align-items-center"
                                style={{ background: "rgba(255,255,255,0.18)", border: "1px solid rgba(255,255,255,0.45)", color: "#fff", borderRadius: 8, padding: "6px 16px", fontWeight: 700, fontSize: 13, cursor: "pointer" }}
                            >
                                <i className="fal fa-arrow-left mr-2" />Back
                            </button>
                        </div>
                    </div>

                    {/* ── Table ── */}
                    <div style={{ padding: "20px 24px" }}>
                        <div style={{ border: "1px solid #e5e7eb", borderRadius: 12, padding: 16, background: "#fff" }}>
                            <DataTableWithOutSearch
                                parentData={rows}
                                particlecolumns={this.articlecolumns}
                                tableHeading={this.state.tableHeaderData}
                                defaultSorted={this.defaultSorted}
                                name={this.state.tableHeaderData.Title}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default compose(
    withRouter,
    graphql(FETCH_PROCTORING_EXAMS, {
        options: props => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_id: props.location && props.location.state ? parseInt(props.location.state.exam_id) : null
            },
            fetchPolicy: 'network-only'
        }),
        name: "getProctoringExams"
    })
)(ProctoringStudentDetails);
